module.exports = __webpack_public_path__ + "static/media/hamburger.bc10105e.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/views/pages/admin/hamburger.png
 ** module id = 559
 ** module chunks = 0
 **/